// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__L8aet","show":"Modal_show__lwSk5","modal":"Modal_modal__E7xdR"};